import type { BariPreAddGeneralPractitionerData } from '@common/validation/customControls/bariPre/bariPreAddGeneralPractitioner/v1/bariPreAddGeneralPractitionerSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './bariPreAddGeneralPractitionerData';
import { BariPreAddGeneralPractitionerEdit } from './BariPreAddGeneralPractitionerEdit';
import { BariPreAddGeneralPractitionerRead } from './BariPreAddGeneralPractitionerRead';

CustomControlRegistry.instance.register<BariPreAddGeneralPractitionerData>({
    EditElement: BariPreAddGeneralPractitionerEdit,
    ReadElement: BariPreAddGeneralPractitionerRead,
    code: CustomControlCode.BariPreAddGeneralPractitioner,
    initialData,
    version: 1,
});
